export const GUIDED_POLICY_FUNDING_ASSUMPTION =
  "Fixed-term premiums are currently modeled as a lump-sum deduction from account balances. More accurate modeling is coming soon to deduct premiums over time to match the policy's premium schedule.";

export function hasRecurringPremiumStructure(
  policy: Pick<PolicyFundingSource, 'policyPremiumMonthlyCost'> | null | undefined,
): boolean {
  return (policy?.policyPremiumMonthlyCost ?? 0) > 0;
}
